<template>
    <div>
    <AlertMessages
      v-if="alertValue"
      :alert-type="alertType"
      :alert-msg="alertMsg"
      @reset="alertValue = false"
    />
  <v-row>
    <v-col cols="12" class="mx-auto">
      <span class="float-right">
        <v-menu v-if="mobile()" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="px-5 py-2"
              height="100%"
              icon
              v-bind="attrs"
              v-on="on"
              style="z-index: 6;"
            >
              <v-icon large>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list class="menulist-drawer" data-testid="menu-list">
            <v-list-item @click="showActiveBoosters" :class="page == 'boosters' ? 'accent--text' : ''">
              <v-list-item-title>{{ $t("spaceBoosters") }}</v-list-item-title>
              <v-chip small color="disabled" text-color="greytext" class="mx-2 px-2">
                {{ peopleStatistics.booster_count }}
              </v-chip>
            </v-list-item>
            <v-list-item @click="showActivePeople" :class="page == 'members' ? 'accent--text' : ''">
              <v-list-item-title>{{ $t("spaceMembers") }}</v-list-item-title>
              <v-chip small color="disabled" text-color="greytext" class="mx-2 px-2">
                {{ peopleStatistics.participant_count}}
              </v-chip>
            </v-list-item>

            <v-list-item
              v-if="
                productPlan.attributes && productPlan.attributes.name == 'Free'
              "
            >
              <v-list-item-title>{{ $t("spaceGuests") }}</v-list-item-title>
              <v-chip class="px-2" x-small color="accent" text-color="white"
                >PRO</v-chip
              >
            </v-list-item>
            <v-list-item v-else @click="showGuests" :class="page == 'guests' ? 'accent--text' : ''">
              <v-list-item-title>{{ $t("spaceGuests") }}</v-list-item-title>
              <v-chip small color="disabled" text-color="greytext" class="mx-2 px-2">
                {{ peopleStatistics.guests_count}}
              </v-chip>
            </v-list-item>
            <v-list-item @click="showPendingInvites" :class="page == 'invites' ? 'accent--text' : ''">
              <v-list-item-title>{{ $t("pendingInvites") }}</v-list-item-title>
              <v-chip small color="disabled" text-color="greytext" class="mx-2 px-2">
                {{ peopleStatistics.total_invites}}
              </v-chip>
            </v-list-item>
          </v-list>
        </v-menu>
      </span>
      <p
      v-if="page == 'boosters'"
        :class="
          mobile()
            ? 'text-h5 font-weight-bold ml-16 mr-16'
            : 'text-h5 font-weight-bold'
        "
        :align="mobile() ? 'center' : 'left'"
      >
        {{ $t("spaceUsersTitle") }}
      </p>
      <p
      v-if="page == 'members'"
        :class="
          mobile()
            ? 'text-h5 font-weight-bold ml-16 mr-16'
            : 'text-h5 font-weight-bold'
        "
        :align="mobile() ? 'center' : 'left'"
      >
        {{ $t("spaceUsersTitle") }}
      </p>
      <p
      v-if="page == 'guests'"
        :class="
          mobile()
            ? 'text-h5 font-weight-bold ml-16 mr-16'
            : 'text-h5 font-weight-bold'
        "
        :align="mobile() ? 'center' : 'left'"
      >
        {{ $t("spaceGuestsTitle") }}
      </p>
      <p
      v-if="page == 'invites'"
        :class="
          mobile()
            ? 'text-h5 font-weight-bold ml-16 mr-16'
            : 'text-h5 font-weight-bold'
        "
        :align="mobile() ? 'center' : 'left'"
      >
        {{ $t("spaceInvitesTitle") }}
      </p>
      <p v-if="!mobile() && page == 'boosters'" class="text-body-1 greytext--text">
        {{ $t('spaceBoostersText') }}
      </p>
      <p v-if="!mobile() && page == 'members'" class="text-body-1 greytext--text">
        {{ $t('spaceUsersText') }}
      </p>
      <p v-if="!mobile() && page == 'guests'" class="text-body-1 greytext--text">
        {{ $t('spaceGuestsText') }}
      </p>
      <p v-if="!mobile() && page == 'invites'" class="text-body-1 greytext--text">
        {{ $t('spaceInvitesText') }}
      </p>
    </v-col>
    <v-col v-if="!mobile()" cols="11" class="mr-auto ml-0 custom-tab-menu py-0">
      <v-list class="py-0" flat>
        <v-list-item @click="showActiveBoosters" :class="page == 'boosters' ? 'accent--text' : ''"
          >{{ $t("spaceBoosters") }}
          <v-chip small color="disabled" text-color="greytext" class="mx-2 px-2">
             {{ peopleStatistics.booster_count }}
          </v-chip>
        </v-list-item>
        <v-list-item @click="showActivePeople" :class="page == 'members' ? 'accent--text' : ''">
          {{ $t("spaceMembers") }}
          <v-chip small color="disabled" text-color="greytext" class="mx-2 px-2">
            {{ peopleStatistics.participant_count}}
          </v-chip>
        </v-list-item>

        <v-list-item
          v-if="productPlan.attributes && productPlan.attributes.name == 'Free'"
        >
          {{ $t("spaceGuests") }}
          <v-chip
            class="px-2"
            x-small
            color="accent"
            style="top: -10px;right:0px"
            text-color="white"
            >PRO</v-chip
          >
        </v-list-item>
        <v-list-item v-else @click="showGuests" :class="page == 'guests' ? 'accent--text' : ''">
          {{ $t("spaceGuests") }}
          <v-chip small color="disabled" text-color="greytext" class="mx-2 px-2">
             {{ peopleStatistics.guests_count}}
          </v-chip>
        </v-list-item>
        <v-list-item @click="showPendingInvites" :class="page == 'invites' ? 'accent--text' : ''">
          {{ $t("pendingInvites") }}
          <v-chip small color="disabled" text-color="greytext" class="mx-2 px-2">
            {{ peopleStatistics.total_invites}}
          </v-chip>
        </v-list-item>
      </v-list>
    </v-col>
  </v-row>
    </div>
</template>
<script>
import i18n from '../../plugins/i18n'
import AlertMessages  from '../../components/AlertMessages'
import { repeatedMethodsMixin } from "../../mixins/repeatedMethodsMixin";
export default {
  components: {
        AlertMessages,
    },
  mixins: [repeatedMethodsMixin],
  props: {
        page: {
          type: String,
          default: 'boosters'
        }
    },
  data() {
    return {
      valid: true,
      alertMsg: "",
      alertType: "",
      alertValue: false,
      spaceId: window.$cookies.get("space_id"),
      role: localStorage.space ? JSON.parse(localStorage.space).role : "",
    };
  },
  computed: {
    productPlan() {
      return this.$store.state.productPlan;
    },
    peopleStatistics() {
        return this.$store.state.peopleStatistics
      }
  },
  mounted() {
      this.getSpaceUsersStatistics()
    },
  async created() {
    //await this.getSpaceUsersStatistics()
  },
  methods: {
    showPendingInvites() {
      this.$router.push({ path: "/audiences/invites" });
    },
    showActivePeople() {
      this.$router.push({ path: "/audiences/people" });
    },
    showGuests() {
      this.$router.push({ path: "/audiences/guests" });
    },
    showActiveBoosters() {
      this.$router.push({ path: "/audiences/boosters" });
    },
    getSpaceUsersStatistics(){
      this.$store.dispatch("getSpaceUsersStatistics", this.spaceId).catch(() => {
            this.alertValue = true
            this.alertType = 'error'
            this.alertMsg =  i18n.t('serverError')  
      })
    },
  },
};
</script>


